import React from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {RichText} from "prismic-reactjs";
import CallToActionSection from "../sections/CallToActionSection";
import Slider from 'react-slick';
import DownArrow from "../parts/DownArrow";
import {Helmet} from "react-helmet";
import {site} from "../config";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";

function NextArrow(props) {
  const {className, style, onClick} = props;
  return (
    <button
      className={className}
      onClick={onClick}
    >&#8594;</button>
  );
}

function PrevArrow(props) {
  const {className, style, onClick} = props;
  return (
    <button
      className={className}
      onClick={onClick}
    >&#8592;</button>
  );
}

class TeamPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
    window.analytics.page("Team");
  }

  componentDidUpdate() {
    if ((this.slider1 && this.slider2) && !(this.state.nav1 && this.state.nav2)) {
      this.setState({
        nav1: this.slider1,
        nav2: this.slider2
      });
    }
  }

  render() {
    window.prerenderReady = false;
    if (this.props.page && this.props.page.doc) {
      window.prerenderReady = true;
      const data = this.props.page.doc.data;
      const textSliderSettings = {
        fade: true,
        arrows: false,
        asNavFor: this.state.nav2,
      };
      const imageSliderSettings = {
        fade: true,
        arrows: false,
        asNavFor: this.state.nav1,
      };
      const arrowSliderSettings = {
        arrows: true,
        asNavFor: this.state.nav1,
        prevArrow: <PrevArrow/>,
        nextArrow: <NextArrow/>,
      };
      return (
        <div className={'page-team'}>
          <Helmet>
            <title>{site.titlePrefix + 'Team'}</title>
            {metaTitles(site.titlePrefix + 'Team')}
            {metaDescriptions(RichText.asText(data.hero_message))}
          </Helmet>
          <section className={'hero'} id={'hero'}>
            <div className={'container'}>
              <h1 className={'title'}>{data.hero_title}</h1>
              <div className={'brief'}>{RichText.render(data.hero_message)}</div>
            </div>
            <DownArrow scrollPastId={'hero'}/>
          </section>
          <div className={'content'}>
            <section className={'vision'}>
              <div className={'container'}>
                <div className={'image'} data-aos="grid-fade-up"/>
                <div className={'text'} data-aos="grid-fade-up">
                  <h2 className={'title'}>{data.vision_title}</h2>
                  <div className={'brief'}>
                    {RichText.render(data.vision_brief)}
                  </div>
                </div>
              </div>
            </section>
            <section className={'team'}>
              <div className={'container'} data-aos="grid-fade-up">
                <h2 className={'title'}>{data.team_title}</h2>
                <ul className={'team'}>
                  {data.team_members.map((member) => (
                    <li key={member.name}>
                      <div className={'image'}>
                        <img src={member.photo.url} alt={member.photo.alt}/>
                      </div>
                      <div className={'text'}>
                        <header>
                          <h3 className={'name'}>{member.name}</h3>
                          <div className={'title'}>{member.role}</div>
                        </header>
                        <div className={'brief'}>{RichText.render(member.brief)}</div>
                      </div>
                      <script type="application/ld+json">
                      {`{
                        "@context": "http://schema.org",
                        "@type": "Person",
                        "name": "${member.name}",
                        "jobTitle": "${member.role}",
                        "description": "${RichText.asText(member.brief)}",
                        "image": "${member.photo.url}"
                      }`}
                      </script>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <section className={'values'}>
              <div className={'container'}>
                <div className={'text'} data-aos="grid-fade-up">
                  <h2 className={'title'}>{data.values_title}</h2>
                  <Slider {...textSliderSettings} ref={slider => this.slider1 = slider}
                          className={'values-texts'}>
                    {data.values.map((value, index) => (
                      <div className={'value-text'} key={value.message}>
                        <div
                          className={'number'}>{(index + 1).toString().padStart(2, '0')}</div>
                        <div className={'value'}>{value.message}</div>
                      </div>
                    ))}
                  </Slider>
                  <Slider {...arrowSliderSettings} className={'values-arrows'}>
                    {data.values.map((value) => (
                      <div key={value.message}/>
                    ))}
                  </Slider>
                  <div className={'values-arrows'}/>
                </div>
                <div className={'image'} data-aos="grid-fade-up">
                  <Slider {...imageSliderSettings} ref={slider => this.slider2 = slider}
                          className={'values-images'}>
                    {data.values.map((value) => (
                      <div className={'value-image'} key={value.message}>
                        <div className={'image'}>
                          <img src={value.image.url} alt={value.image.alt}/>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </section>
            <CallToActionSection/>
          </div>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(TeamPage, 'team_page');


// WEBPACK FOOTER //
// ./src/pages/TeamPage.js